import { registerIcons } from '@fluentui/style-utilities'

// Register custom FluentUI icons that aren't included in the default initialization
export function registerCustomIcons(): void {
  // Register only the missing icons with their unicode points from the Fabric MDL2 icon set
  registerIcons({
    fontFace: {
      fontFamily: 'FabricMDL2Icons',
    },
    icons: {
      Building: '\uE038',
      School: '\uE7BE',
      Sunrise: '\uE706',
      Sunset: '\uE706', // Using the same as sunrise for now
      // Register the standard directions icon (without "Icon" suffix)
      Directions: '\uE816',
    },
  })
}
